<template>
  <suffix :size="70" :class="{vertical: verticalOrientation, horizontal: !verticalOrientation}">
    <slot-array :length="3">
      <template :slot="downPosition" v-if="!hideMoveControls">
        <button :disabled="disabled || (!disabled && card.isLast)" @click.prevent.stop="card.moveDown" :id="`moveDown_${card.client_id}`" class="btn-icon clear-area">
          <icon :class="`arrow-chevron ${downWord}`"></icon>
          <span class="sr-only">Move {{card.displayName}} one step {{downWord}}</span>
        </button>
      </template>
      <template :slot="upPosition"  v-if="!hideMoveControls">
        <button :disabled="disabled || (!disabled && card.isFirst)" @click.prevent.stop="card.moveUp" :id="`moveUp_${card.client_id}`" class="btn-icon clear-area">
          <icon :class="`arrow-chevron ${upWord}`"></icon>
          <span class="sr-only">Move {{card.displayName}} one step {{upWord}}</span>
        </button>
      </template>
      <template :slot="3">
        <button
          @click.stop="remove"
          class="btn-icon clear-to-red close"
          :class="{disabled: disabled || !removeEnabled}"
          :aria-disabled="disabled || !removeEnabled"
          v-tooltip="removeTooltip"
        >
          <icon class="times"></icon>
          <span class="sr-only">Delete {{card.displayName}}</span>
        </button>
      </template>
    </slot-array>
  </suffix>
</template>

<script lang="ts">
  import Vue from "vue";
  import {ISortable} from "../interfaces/propertyInterfaces";
  import disabledMixin from "../mixins/disabledMixin";
  import SlotArray from "./layouts/slotArray.vue";

  export default Vue.extend({
    components: {
      SlotArray,
    },
    mixins: [
      disabledMixin,
    ],
    props: {
      card: {
        type: Object as () => ISortable,
        required: true,
      },
      hideMoveControls:{
        type: Boolean,
        default: false
      },
      verticalOrientation: {
        type: Boolean,
        default: false
      },
      switchOrientation: {
        type: Boolean,
        default: false
      },
      removeEnabled: {
        type: Boolean,
        default: true
      },
      removeTooltip: {
        type: String,
        default: null
      }
    },
    data: function () {
      return {}
    },
    computed: {
      upWord(): string {
        if (this.switchOrientation) {
          return 'left';
        } else {
          return 'up';
        }
      },
      downWord(): string {
        if (this.switchOrientation) {
          return 'right';
        } else {
          return 'down';
        }
      },
      upPosition(): 1 | 2 {
        if (this.switchOrientation || this.verticalOrientation) {
          return 1;
        } else {
          return 2;
        }
      },
      downPosition(): 1 | 2 {
        if (this.switchOrientation || this.verticalOrientation) {
          return 2;
        } else {
          return 1;
        }
      },
    },
    methods: {
      remove(event) {
        this.$emit('remove:card', this.card);
      }
    }
  });
</script>